function fallbackCopying(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.padding = '0';
    textarea.style.width = '2em';
    textarea.style.height = '2em';
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.position = 'fixed';
    textarea.style.background = 'transparent';
    textarea.style.zIndex = '-2147483647';

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    $(textarea).trigger('focus');
    $(textarea).trigger('select');

    document.execCommand('copy');
    document.body.removeChild(textarea);
}

export function copyToClipboard(text: string): void {
    if (!navigator.clipboard) {
        fallbackCopying(text);
        return;
    }
    navigator.clipboard.writeText(text);
};
